var R = (e, n, o) => new Promise((l, u) => {
  var d = (c) => {
    try {
      a(o.next(c));
    } catch (g) {
      u(g);
    }
  }, f = (c) => {
    try {
      a(o.throw(c));
    } catch (g) {
      u(g);
    }
  }, a = (c) => c.done ? l(c.value) : Promise.resolve(c.value).then(d, f);
  a((o = o.apply(e, n)).next());
});
import { defineComponent as D, ref as I, computed as j, watch as F, onMounted as q, onBeforeUnmount as J, nextTick as K, openBlock as W, createElementBlock as L, normalizeStyle as U, unref as B, renderSlot as Q, Fragment as Y, renderList as Z } from "vue";
var ee = typeof global == "object" && global && global.Object === Object && global;
const te = ee;
var ne = typeof self == "object" && self && self.Object === Object && self, re = te || ne || Function("return this")();
const H = re;
var ie = H.Symbol;
const k = ie;
var G = Object.prototype, oe = G.hasOwnProperty, ae = G.toString, x = k ? k.toStringTag : void 0;
function le(e) {
  var n = oe.call(e, x), o = e[x];
  try {
    e[x] = void 0;
    var l = !0;
  } catch (d) {
  }
  var u = ae.call(e);
  return l && (n ? e[x] = o : delete e[x]), u;
}
var ue = Object.prototype, ce = ue.toString;
function fe(e) {
  return ce.call(e);
}
var se = "[object Null]", de = "[object Undefined]", P = k ? k.toStringTag : void 0;
function ge(e) {
  return e == null ? e === void 0 ? de : se : P && P in Object(e) ? le(e) : fe(e);
}
function me(e) {
  return e != null && typeof e == "object";
}
var be = "[object Symbol]";
function pe(e) {
  return typeof e == "symbol" || me(e) && ge(e) == be;
}
var he = /\s/;
function ve(e) {
  for (var n = e.length; n-- && he.test(e.charAt(n)); )
    ;
  return n;
}
var ye = /^\s+/;
function Te(e) {
  return e && e.slice(0, ve(e) + 1).replace(ye, "");
}
function C(e) {
  var n = typeof e;
  return e != null && (n == "object" || n == "function");
}
var _ = 0 / 0, Se = /^[-+]0x[0-9a-f]+$/i, xe = /^0b[01]+$/i, Oe = /^0o[0-7]+$/i, we = parseInt;
function z(e) {
  if (typeof e == "number")
    return e;
  if (pe(e))
    return _;
  if (C(e)) {
    var n = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = C(n) ? n + "" : n;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = Te(e);
  var o = xe.test(e);
  return o || Oe.test(e) ? we(e.slice(2), o ? 2 : 8) : Se.test(e) ? _ : +e;
}
var je = function() {
  return H.Date.now();
};
const A = je;
var ke = "Expected a function", Ce = Math.max, Ee = Math.min;
function $e(e, n, o) {
  var l, u, d, f, a, c, g = 0, O = !1, m = !1, p = !0;
  if (typeof e != "function")
    throw new TypeError(ke);
  n = z(n) || 0, C(o) && (O = !!o.leading, m = "maxWait" in o, d = m ? Ce(z(o.maxWait) || 0, n) : d, p = "trailing" in o ? !!o.trailing : p);
  function h(t) {
    var i = l, s = u;
    return l = u = void 0, g = t, f = e.apply(s, i), f;
  }
  function E(t) {
    return g = t, a = setTimeout(v, n), O ? h(t) : f;
  }
  function b(t) {
    var i = t - c, s = t - g, S = n - i;
    return m ? Ee(S, d - s) : S;
  }
  function y(t) {
    var i = t - c, s = t - g;
    return c === void 0 || i >= n || i < 0 || m && s >= d;
  }
  function v() {
    var t = A();
    if (y(t))
      return T(t);
    a = setTimeout(v, b(t));
  }
  function T(t) {
    return a = void 0, p && l ? h(t) : (l = u = void 0, f);
  }
  function $() {
    a !== void 0 && clearTimeout(a), g = 0, l = c = u = a = void 0;
  }
  function w() {
    return a === void 0 ? f : T(A());
  }
  function r() {
    var t = A(), i = y(t);
    if (l = arguments, u = this, c = t, i) {
      if (a === void 0)
        return E(c);
      if (m)
        return clearTimeout(a), a = setTimeout(v, n), h(c);
    }
    return a === void 0 && (a = setTimeout(v, n)), f;
  }
  return r.cancel = $, r.flush = w, r;
}
var Ie = "Expected a function";
function We(e, n, o) {
  var l = !0, u = !0;
  if (typeof e != "function")
    throw new TypeError(Ie);
  return C(o) && (l = "leading" in o ? !!o.leading : l, u = "trailing" in o ? !!o.trailing : u), $e(e, n, {
    leading: l,
    maxWait: n,
    trailing: u
  });
}
const Ae = /* @__PURE__ */ D({
  __name: "VueFlexWaterfall",
  props: {
    height: null,
    alignContent: null,
    col: { default: 1 },
    colSpacing: { default: 0 },
    breakAt: { default: () => ({}) },
    breakByContainer: { type: Boolean, default: !1 }
  },
  emits: ["orderUpdated"],
  setup(e, { expose: n, emit: o }) {
    const l = e, u = I(0), d = I(0), f = I();
    let a;
    const c = j(() => {
      const r = Number(l.col), t = !r || r < 1 ? 1 : r, i = m.value.find(([s]) => d.value && d.value <= s);
      return Math.floor(i ? i[1] : t);
    }), g = j(() => h(l.colSpacing)), O = j(
      () => h(l.height) || (u.value > 0 ? `${u.value}px` : "")
    ), m = j(() => {
      const r = [];
      return Object.entries(l.breakAt).forEach(([t, i]) => {
        const s = [Number(t) || 0, Number(i) || 0];
        Math.min(...s) > 0 && r.push(s);
      }), typeof window != "undefined" && (r.length ? $() : w()), r.sort(([t], [i]) => t - i);
    }), p = We(y, 100);
    F(m, () => b(), { deep: !0 }), q(() => {
      a = new MutationObserver(() => b()), m.value.length && y(), b(!1), F(c, () => b());
    }), J(() => {
      T(), w();
    });
    function h(r) {
      return r ? Number(r) ? `${r}px` : r : 0;
    }
    function E() {
      return f.value ? Array.from(f.value.children).filter((r) => r.getAttribute("vue-flex-waterfall-split") === null).map((r) => {
        const { marginTop: t, marginBottom: i } = window.getComputedStyle(r), s = r.getBoundingClientRect().height + parseFloat(t) + parseFloat(i);
        return { el: r, ph: s };
      }) : [];
    }
    function b(r = !0) {
      return R(this, null, function* () {
        T(), u.value = 0;
        let t = !1;
        const i = Array(c.value).fill(0);
        (E() || []).forEach(({ el: S, ph: V }) => {
          const M = i.indexOf(Math.min(...i)), X = S.style.order, N = String(M + 1);
          X != N && (S.style.order = N, t = !0), i[M] += V;
        }), u.value = Math.max(...i), yield K(), v(), r && t && o("orderUpdated");
      });
    }
    function y() {
      d.value = l.breakByContainer ? f.value.clientWidth : window.innerWidth;
    }
    function v() {
      a == null || a.observe(f.value, { attributes: !0, childList: !0, subtree: !0 });
    }
    function T() {
      a == null || a.disconnect();
    }
    function $() {
      window.addEventListener("resize", p);
    }
    function w() {
      window.removeEventListener("resize", p);
    }
    return n({ updateOrder: b }), (r, t) => (W(), L("div", {
      ref_key: "container",
      ref: f,
      style: U([{ height: B(O), "align-content": e.alignContent }, { display: "flex", "flex-flow": "column wrap" }]),
      onLoadCapture: t[0] || (t[0] = (i) => b())
    }, [
      Q(r.$slots, "default"),
      (W(!0), L(Y, null, Z(B(c) - 1, (i) => (W(), L("div", {
        "vue-flex-waterfall-split": "",
        key: `split-${i}`,
        style: U([{ order: i, width: B(g) }, { "flex-basis": "100%" }])
      }, null, 4))), 128))
    ], 36));
  }
});
export {
  Ae as VueFlexWaterfall
};
//# sourceMappingURL=vue-flex-waterfall.mjs.map
